var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "10px",
    viewBox: "0 0 14 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-soc-youtube-white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.000000, -70.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.11050674,0.625267639 L7.41464478,0.627141113 C8.44734497,0.635705566 11.1073303,0.678527828 11.8896789,0.892639141 C12.4249573,1.03668211 12.8470154,1.45889281 12.9912109,1.99417113 C13.2123041,2.80203116 13.2437111,4.33337929 13.2479481,4.84158778 L13.2479568,5.10690345 C13.2441501,5.52141303 13.2149648,7.1658259 12.9912109,8.01620484 C12.8470154,8.55148316 12.4249573,8.97354125 11.8896789,9.11758422 C11.0421346,9.3406779 7.99097493,9.37042372 7.19239981,9.37438983 L6.80807274,9.3743656 C6.01138781,9.37024197 2.96672568,9.33931478 2.11032105,9.10736086 C1.57504273,8.96331789 1.15298461,8.54110719 1.00878906,8.00582887 C0.773757262,7.1224047 0.753319714,5.34638548 0.751542536,5.04419252 L0.751542536,4.95602238 C0.753319714,4.65526213 0.773757262,2.88706906 1.00878906,1.99417113 C1.15283203,1.45889281 1.58526609,1.02645875 2.11032105,0.882415781 C2.89266968,0.676483156 5.55265503,0.635296631 6.58535522,0.627059326 L6.88949326,0.625257416 C6.91328969,0.625171611 6.93350037,0.625114407 6.94987174,0.625076271 L7.05012826,0.6250793 C7.06649963,0.625118951 7.08671031,0.625178426 7.11050674,0.625267639 Z M5.75442504,3.12652586 L5.75442504,6.87347414 L9.00729371,5 L5.75442504,3.12652586 Z"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default ForwardRef;